import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse, AxiosInstance } from 'axios';
import {
  DashboardDto,
  LayoutMutateDto,
  MutationOptions,
  MutationResult,
} from '@thingslog/repositories';
import { QueryKeys } from '../enums/QueryKeys';
import { buildDashboardUrl } from './dashboardUrlUtils';

export function createDashboardLayoutClient(axios: AxiosInstance): DashboardLayoutQueryClient {
  return new DashboardLayoutClientImp(axios);
}

class DashboardLayoutClientImp {
  public constructor(private axios: AxiosInstance) {}

  public useUpdateDashboardLayout = (
    options?: MutationOptions<
      DashboardDto,
      { id: string; body: LayoutMutateDto; companyId?: string | number | null }
    >
  ): MutationResult<
    DashboardDto,
    { id: string; body: LayoutMutateDto; companyId?: string | number | null }
  > => {
    return useMutation<
      DashboardDto,
      AxiosError,
      { id: string; body: LayoutMutateDto; companyId?: string | number | null }
    >(
      [QueryKeys.UpdateDashboardLayout],
      ({
        id,
        body,
        companyId,
      }: {
        id: string;
        body: LayoutMutateDto;
        companyId?: string | number | null;
      }) => this.updateDashboardLayout(id, body, companyId),
      options
    );
  };

  private updateDashboardLayout = async (
    id: string,
    body: LayoutMutateDto,
    companyId?: string | number | null
  ): Promise<DashboardDto> => {
    return await this.axios
      .put(buildDashboardUrl(`/dashboard/api/dashboards/${id}/layout`), body, {
        params: companyId != null ? { companyId } : {},
      })
      .then((response: AxiosResponse<DashboardDto>) => response.data);
  };
}

export interface DashboardLayoutQueryClient {
  useUpdateDashboardLayout: (
    options?: MutationOptions<
      DashboardDto,
      { id: string; body: LayoutMutateDto; companyId?: string | number | null }
    >
  ) => MutationResult<
    DashboardDto,
    { id: string; body: LayoutMutateDto; companyId?: string | number | null }
  >;
}
